import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Store } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { UpdateSignalRConnectionStatusAction } from '@ngxs-store/ui-store/ui.actions';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection: HubConnection;

  constructor(private store: Store) {

  }

  public startConnection = () => {
    const accessToken = this.store.selectSnapshot(AuthState.getDecodedToken).token;

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${environment.signalRBaseAddress}?access_token=${accessToken}`)
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    this.hubConnection.start()
      .then(() => {
        this.store.dispatch(new UpdateSignalRConnectionStatusAction({ connected: true }));
        this.hubConnection.onreconnecting(() => this.store.dispatch(new UpdateSignalRConnectionStatusAction({ connected: false })));
        this.hubConnection.onreconnected(() => this.store.dispatch(new UpdateSignalRConnectionStatusAction({ connected: true })));
      })
      .catch(() => this.store.dispatch(new UpdateSignalRConnectionStatusAction({ connected: false })));
  }

  public getHubConnection(): HubConnection {
    return this.hubConnection;
  }

  public stopConnection() {
    this.hubConnection.stop();
  }
}
